module.exports = __webpack_public_path__ + "img/dinghan-logo-3.0695bcb1.jpg";